import { axios, longAxios, implAxios, gateWayAxios } from '@/utils/request'

const api = {
  user: '/api/user',
  role: '/api/role',
  service: '/api/service',
  permission: '/api/permission',
  permissionNoPager: '/api/permission/no-pager'
}

export default api

//post
export function postAction(url, parameter) {
  return axios({
    url: url,
    method: 'post',
    data: parameter
  })
}


//post method= {post | put}
export function httpAction(url, parameter, method) {
  return axios({
    url: url,
    method: method,
    data: parameter
  })
}

//put
export function putAction(url, parameter) {
  return axios({
    url: url,
    method: 'put',
    data: parameter
  })
}
export function putParamsAction(url, parameter) {
  return axios({
    url: url,
    method: 'put',
    params: parameter
  })
}

//get
export function getAction(url, parameter) {
  return axios({
    url: url,
    method: 'get',
    params: parameter
  })
}

//deleteAction
export function deleteAction(url, parameter) {
  return axios({
    url: url,
    method: 'delete',
    params: parameter
  })
}

export function getUserList(parameter) {
  return axios({
    url: api.user,
    method: 'get',
    params: parameter
  })
}

export function getRoleList(parameter) {
  return axios({
    url: api.role,
    method: 'get',
    params: parameter
  })
}

export function getServiceList(parameter) {
  return axios({
    url: api.service,
    method: 'get',
    params: parameter
  })
}

export function getPermissions(parameter) {
  return axios({
    url: api.permissionNoPager,
    method: 'get',
    params: parameter
  })
}

// id == 0 add     post
// id != 0 update  put
export function saveService(parameter) {
  return axios({
    url: api.service,
    method: parameter.id == 0 ? 'post' : 'put',
    data: parameter
  })
}

/**
 * 下载文件 用于excel导出
 * @param url
 * @param parameter
 * @returns {*}
 */
export function downFile(url, parameter) {
  return longAxios({
    url: url,
    params: parameter,
    method: 'get',
    responseType: 'blob'
  })
}

//get method=
export function getCloudApiAction(url, parameter) {
  return implAxios({
    url: url,
    method: 'get',
    params: parameter
  })
}

export function longGetAction(url, parameter) {
  return longAxios({
    url: url,
    method: 'get',
    params: parameter
  })
}

export function longPostAction(url, parameter) {
  return longAxios({
    url: url,
    method: 'post',
    data: parameter
  })
}

export function longPutAction(url, parameter) {
  return longAxios({
    url: url,
    method: 'put',
    data: parameter
  })
}

export function longDeleteAction(url, parameter) {
  return longAxios({
    url: url,
    method: 'delete',
    params: parameter
  })
}

export function gatewayGetAction(url, parameter, headers) {
  return gateWayAxios({
    url: url,
    method: 'get',
    params: parameter,
    headers: headers ? headers : {}
  })
}

export function gatewayPostAction(url, parameter, headers) {
  return gateWayAxios({
    url: url,
    method: 'post',
    data: parameter,
    headers: headers ? headers : {}
  })
}

export function gatewayPutAction(url, parameter, headers) {
  return gateWayAxios({
    url: url,
    method: 'put',
    data: parameter,
    headers: headers ? headers : {}
  })
}

export function gatewayDeleteAction(url, parameter, headers) {
  return gateWayAxios({
    url: url,
    method: 'delete',
    params: parameter,
    headers: headers ? headers : {}
  })
}
